var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E1DABE"
    },
    points: "449.78,512 62.22,512 62.22,0 345.627,0 449.78,104.158 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3BEA4"
    },
    points: "345.627,104.158 449.78,104.158 345.627,0 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      enableBackground: "new"
    },
    d: "M394.362,176.107c0,3.161-2.563,5.719-5.719,5.719H123.361 c-3.156,0-5.719-2.563-5.719-5.719l0,0c0-3.156,2.563-5.719,5.719-5.719h265.277C391.8,170.388,394.362,172.946,394.362,176.107 L394.362,176.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      enableBackground: "new"
    },
    d: "M394.362,220.434c0,3.156-2.563,5.719-5.719,5.719H123.361 c-3.156,0-5.719-2.563-5.719-5.719l0,0c0-3.161,2.563-5.719,5.719-5.719h265.277C391.8,214.711,394.362,217.273,394.362,220.434 L394.362,220.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      enableBackground: "new"
    },
    d: "M394.362,264.757c0,3.161-2.563,5.719-5.719,5.719H123.361 c-3.156,0-5.719-2.563-5.719-5.719l0,0c0-3.156,2.563-5.719,5.719-5.719h265.277C391.8,259.038,394.362,261.6,394.362,264.757 L394.362,264.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      enableBackground: "new"
    },
    d: "M394.362,309.084c0,3.161-2.563,5.719-5.719,5.719H123.361 c-3.156,0-5.719-2.563-5.719-5.719l0,0c0-3.156,2.563-5.719,5.719-5.719h265.277C391.8,303.365,394.362,305.927,394.362,309.084 L394.362,309.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      enableBackground: "new"
    },
    d: "M394.362,353.411c0,3.156-2.563,5.719-5.719,5.719H123.361 c-3.156,0-5.719-2.563-5.719-5.719l0,0c0-3.161,2.563-5.719,5.719-5.719h265.277C391.8,347.692,394.362,350.25,394.362,353.411 L394.362,353.411z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.502,459.624h-195c-1.891,0-3.426-1.535-3.426-3.426c0-1.891,1.535-3.426,3.426-3.426h195 c1.891,0,3.426,1.535,3.426,3.426C356.928,458.089,355.393,459.624,353.502,459.624z"
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7FADC4"
    },
    cx: 168.533,
    cy: 88.567,
    r: 40.412
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5A8DA9"
    },
    cx: 168.533,
    cy: 88.567,
    r: 29.089
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.241,88.567c0,2.252-1.827,4.079-4.084,4.079h-68.743c-2.257,0-4.084-1.827-4.084-4.079l0,0 c0-2.257,1.827-4.084,4.084-4.084h68.743C300.414,84.484,302.241,86.311,302.241,88.567L302.241,88.567z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.241,111.567c0,2.257-1.827,4.084-4.084,4.084h-68.743c-2.257,0-4.084-1.827-4.084-4.084l0,0 c0-2.252,1.827-4.079,4.084-4.079h68.743C300.414,107.488,302.241,109.315,302.241,111.567L302.241,111.567z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.727,457.729c20.939-10.977,40.846-23.584,60.918-36.041c4.417-2.732,8.857-5.422,13.329-8.067 c2.202-1.32-4.486,15.577-4.819,16.28c-1.832,3.901-1.329,6.144-0.745,10.1c0.288,1.964,2.718,2.421,4.193,1.708 c12.018-5.797,22.588-13.704,34.022-20.515c0.228-0.137-5.998,13.224-7.318,16.527c-1.014,2.54,2.206,4.221,4.193,3.225 c7.272-3.645,12.959-8.209,19.089-13.516c4.166-3.805,8.629-7.24,13.389-10.292c12.607-8.364-0.041,9.798-1.982,14.179 c-1.042,2.348,1.284,5.692,3.906,3.906c8.378-5.705,16.17-11.89,25.069-16.783c-1.398-1.073-2.796-2.151-4.193-3.225 c-1.9,5.226-14.668,24.155-0.927,25.535c16.394,1.649,34.753-9.282,48.849-16.591c3.271-1.695,0.384-6.623-2.882-4.933 c-9.035,4.682-18.249,8.903-27.778,12.489c-4.961,1.864-10.027,3.175-15.325,3.618c-4.993,0.411,2.49-15.613,3.572-18.601 c0.9-2.476-2.156-4.344-4.193-3.225c-8.898,4.892-16.691,11.077-25.069,16.778c1.302,1.302,2.604,2.604,3.906,3.906 c3.403-7.665,7.144-14.8,9.131-22.986c0.498-2.06-1.361-4.152-3.513-3.513c-17.618,5.244-27.86,20.263-43.925,28.312 c1.398,1.073,2.796,2.151,4.193,3.225c2.786-6.971,12.516-15.225,11.47-23.223c-0.16-1.211-0.749-2.476-2.097-2.754 c-10.524-2.147-24.242,11.836-32.514,17.194c-13.069,8.469-2.33-6.765-0.434-11.347c2.01-4.86,2.832-7.72,0.84-12.658 c-0.681-1.686-2.462-2.713-4.193-1.708c-27.175,15.787-53.18,33.451-81.039,48.055C129.587,454.508,132.47,459.437,135.727,457.729 L135.727,457.729z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSvgrepoCom);
export default __webpack_public_path__ + "static/media/document-svgrepo-com.c87c119004e4f09c391ed317d04074ab.svg";
export { ForwardRef as ReactComponent };